module.exports = __webpack_public_path__ + "img/full3-min.cc1dfcde.png";